// @flow
import { error } from './common';
import * as types from '../types/drivers';
import type {
  DRIVER_FETCH_STARTED_TYPE,
  DRIVER_FETCH_SUCCEED_TYPE,
} from '../types/drivers';

export const startFetchingDriver = (id: number): DRIVER_FETCH_STARTED_TYPE => ({
  type: types.DRIVER_FETCH_STARTED,
  payload: id,
});

export const fetchDriverSucceed = (
  id: number,
  first_name: string,
  last_name: string,
  license_type: string,
  license_number: string,
  profile_picture: string,
): DRIVER_FETCH_SUCCEED_TYPE => ({
  type: types.DRIVER_FETCH_SUCCEED,
  payload: {
    id,
    first_name,
    last_name,
    license_type,
    license_number,
    profile_picture,
  },
});

export const fetchDriverFailed = error(types.DRIVER_FETCH_FAILED);



// WEBPACK FOOTER //
// ./src/scripts/actions/drivers.js